export class SoggettoStranieroDTO {
  denominazione: string;

  codice: string;

  nazione: string;
}
